import { WidthContainer } from '@pata-app/ui-document';
import { Button } from '@pata-app/ui-form';
import { Image } from '@pata-app/ui-media';

import React from 'react';

import { TextWithHighlight } from '../../../../components/textWithHighlight/textWithHighlight';
import { getEnv } from '../../../../lib/utils/getEnv';
import { businessBenefits } from './businessBenefits.config';
import {
  ActionContainer,
  BusinessBenefit,
  BusinessBenefitsContainer,
  BusinessBenefitsContent,
  UnlimitedContainer,
  UnlimitedLabel,
} from './businessBenefits.styled';

const { VITE_PARTNERS_BASE_URL, VITE_CDN_BASE_URL } = getEnv();

const BusinessBenefits = () => {
  const handleSignUpClick = () => {
    window.location.href = `${VITE_PARTNERS_BASE_URL}/sign-up`;
  };

  const handleBookDemo = () => {
    window.location.href = `https://meetings.hubspot.com/pata/demo`;
  };

  return (
    <BusinessBenefitsContainer>
      <WidthContainer noBackground>
        <BusinessBenefitsContent>
          <TextWithHighlight>
            <h2>
              Subscription-free booking software for dog trainers with access to <span>unlimited features</span>
            </h2>
          </TextWithHighlight>

          <UnlimitedContainer>
            <UnlimitedLabel>
              <strong>Unlimited</strong>
            </UnlimitedLabel>
            <ul>
              {businessBenefits.map((benefit) => (
                <BusinessBenefit key={benefit.title}>
                  <strong>{benefit.title}</strong>
                  <p>{benefit.description}</p>
                </BusinessBenefit>
              ))}
            </ul>
          </UnlimitedContainer>

          <ActionContainer>
            <Button onClick={handleSignUpClick}>Sign up today</Button>
            <Button buttonType="secondary" onClick={handleBookDemo}>
              Book a demo
            </Button>
          </ActionContainer>
        </BusinessBenefitsContent>
        <Image
          src={`${VITE_CDN_BASE_URL}/images/image-dog-with-tongue-out.webp`}
          alt="Happy dog with tongue hanging out"
          height={1500}
          width={2500}
        />
      </WidthContainer>
    </BusinessBenefitsContainer>
  );
};

export default BusinessBenefits;
